<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">UPLOAD FOTO</h6>
        <b-row>
            <b-col sm="6">
                <!-- <b-form-group label="Foto Identitas">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper" >
                            <div class="foto-content-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.activeFotoIdentitasBase64)">
                                <img :src="dataFoto.activeFotoIdentitasBase64" alt="Foto Identitas">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(1)">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>

                        <div class="foto-action-wrapper">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="dataFoto.fotoIdentitas" name="fotoIdentitas"
                                    :state="Boolean(dataFoto.fotoIdentitas)"
                                    placeholder="Foto Identitas"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    @input="browseFile(1)"
                                ></b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto(1)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                
                            <div class="action-reset-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.urlFotoIdentitas) && dataFoto.activeFotoIdentitasBase64 != dataFoto.urlFotoIdentitas">
                                <b-button variant="cancelBtn" @click="resetFoto(1)">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset 
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-form-group> -->
                <b-form-group label="Form Survey">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.activeFotoFormSurveyBase64)">
                                <img :src="dataFoto.activeFotoFormSurveyBase64" :key="dataFoto.activeFotoFormSurveyBase64" alt="Foto Pendukung2">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(5)">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper flex-wrap">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="dataFoto.fotoFormSurvey" name="fotoPendukungTiga"
                                    :state="Boolean(dataFoto.fotoPendukungTiga)"
                                    placeholder="Foto Pendukung"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    ref="fileInput5"
                                    @input="browseFile(5)"
                                ></b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>

                            <!-- DESKTOP -->
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto(5)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                            <!-- DESKTOP -->

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera(5)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                            <!-- MOBILE -->

                            <div class="action-reset-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.urlFotoFormSurvey) && dataFoto.activeFotoFormSurveyBase64 != dataFoto.urlFotoFormSurvey">
                                <b-button variant="cancelBtn" @click="resetFoto(5)">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group label="Form Data Nasabah BPKB">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.activeFotoFormDataBpkbBase64)">
                                <img :src="dataFoto.activeFotoFormDataBpkbBase64" :key="dataFoto.activeFotoFormDataBpkbBase64" alt="Foto Pendukung2">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(6)">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper flex-wrap">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="dataFoto.fotoFormDataBpkb" name="fotoPendukungTiga"
                                    :state="Boolean(dataFoto.fotoPendukungTiga)"
                                    placeholder="Foto Pendukung"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    ref="fileInput6"
                                    @input="browseFile(6)"
                                ></b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>

                            <!-- DESKTOP -->
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto(6)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                            <!-- DESKTOP -->

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera(6)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>
                            </div>
                            <!-- MOBILE -->

                            <div class="action-reset-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.urlFotoFormDataBpkb) && dataFoto.activeFotoFormDataBpkbBase64 != dataFoto.urlFotoFormDataBpkb">
                                <b-button variant="cancelBtn" @click="resetFoto(6)">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group label="Foto Pendukung 1">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.activeFotoPendukung1Base64)">
                                <img :src="dataFoto.activeFotoPendukung1Base64" :key="dataFoto.activeFotoPendukung1Base64" alt="Foto Pendukung1">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(2)">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper flex-wrap">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="dataFoto.fotoPendukung1" name="fotoPendukungSatu"
                                    :state="Boolean(dataFoto.fotoPendukungSatu)"
                                    placeholder="Foto Pendukung"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    ref="fileInput2"
                                    @input="browseFile(2)"
                                ></b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>

                            <!-- DESKTOP -->
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto(2)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                            <!-- DESKTOP -->

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera(2)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>
                            </div>
                            <!-- MOBILE -->

                            <div class="action-reset-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.urlFotoPendukung1) && dataFoto.activeFotoPendukung1Base64 != dataFoto.urlFotoPendukung1">
                                <b-button variant="cancelBtn" @click="resetFoto(2)">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group label="Foto Pendukung 2">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.activeFotoPendukung2Base64)">
                                <img :src="dataFoto.activeFotoPendukung2Base64" :key="dataFoto.activeFotoPendukung2Base64" alt="Foto Pendukung2">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(3)">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper flex-wrap">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="dataFoto.fotoPendukung2" name="fotoPendukungDua"
                                    :state="Boolean(dataFoto.fotoPendukungDua)"
                                    placeholder="Foto Pendukung"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    ref="fileInput3"
                                    @input="browseFile(3)"
                                ></b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>
                            <!-- DESKTOP -->
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto(3)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                            <!-- DESKTOP -->

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera(3)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>
                            </div>
                            <!-- MOBILE -->

                            <div class="action-reset-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.urlFotoPendukung2) && dataFoto.activeFotoPendukung2Base64 != dataFoto.urlFotoPendukung2">
                                <b-button variant="cancelBtn" @click="resetFoto(3)">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-form-group>
                <b-form-group label="Foto Pendukung 3">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.activeFotoPendukung3Base64)">
                                <img :src="dataFoto.activeFotoPendukung3Base64" :key="dataFoto.activeFotoPendukung3Base64" alt="Foto Pendukung2">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview(4)">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="dataFoto.fotoPendukung3" name="fotoPendukungTiga"
                                    :state="Boolean(dataFoto.fotoPendukungTiga)"
                                    placeholder="Foto Pendukung"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    ref="fileInput4"
                                    @input="browseFile(4)"
                                ></b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>
                            
                            <!-- DESKTOP -->
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="pgiBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFoto(4)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera
                                </b-button>
                            </div>
                            <!-- DESKTOP -->

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera(4)">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>
                            </div>
                            <!-- MOBILE -->

                            <div class="action-reset-wrapper" v-if="!$helper.isNullOrEmpty(dataFoto.urlFotoPendukung3) && dataFoto.activeFotoPendukung3Base64 != dataFoto.urlFotoPendukung3">
                                <b-button variant="cancelBtn" @click="resetFoto(4)">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-form-group>
         
            </b-col>
            <!-- <b-col>
                    <label>* Contoh pengambilan foto ktp</label>
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper-potrait" >
                            <img src="../../../public/img/Screenshot 2023-06-19 at 11.40.20.jpg" alt="">
                        </div>
                    </div>
            </b-col> -->

            <input
                style="display: none;"
                ref="cameraInput"
                type="file" 
                accept="image/*" 
                capture="environment" 
                @change="handleKameraMobile"
            />
        </b-row>
        <ModalWebCam @photoTaken="setResult" />
        <ModalPreview :fotoPreview="activeFotoPreview" />
    </div>
</template>

<script>
import ModalWebCam from '../webcam/ModalWebCam'
import ModalPreview from '../../components/webcam/ModalPreview'

export default {
    name: 'data-foto',
    components: {
        ModalWebCam,
        ModalPreview
    },
    data(){
        return{
            activeId: null,
            activeFotoPreview: "",
        }
    },
    props: {
        dataFoto: { type: Object, required: true },
    },
    methods: {

        ambilFoto(id){
            this.activeId = id
            this.$bvModal.show("modal-ambil-foto");
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            if(this.activeId == 1){
                this.dataFoto.fotoIdentitasBase64 = newResult
                this.dataFoto.activeFotoIdentitasBase64 = newResult
            }else if(this.activeId == 2){
                this.dataFoto.fotoPendukung1Base64 = newResult
                this.dataFoto.activeFotoPendukung1Base64 = newResult
            }else if(this.activeId == 3){
                this.dataFoto.fotoPendukung2Base64 = newResult
                this.dataFoto.activeFotoPendukung2Base64 = newResult
            }else if(this.activeId == 4){
                this.dataFoto.fotoPendukung3Base64 = newResult
                this.dataFoto.activeFotoPendukung3Base64 = newResult
            }else if(this.activeId == 5){
                this.dataFoto.fotoFormSurveyBase64 = newResult
                this.dataFoto.activeFotoFormSurveyBase64 = newResult
            }else {
                this.dataFoto.urlFotoFormDataBpkbBase64 = newResult
                this.dataFoto.activeFotoFormDataBpkbBase64 = newResult
            }
        },

        resetFoto(id) {
            if(id == 1){
                this.dataFoto.activeFotoIdentitasBase64 = this.dataFoto.urlFotoIdentitas
            }else if(id == 2){
                this.dataFoto.activeFotoPendukung1Base64 = this.dataFoto.urlFotoPendukung1
            }else if(id == 3){
                this.dataFoto.activeFotoPendukung2Base64 = this.dataFoto.urlFotoPendukung2
            }else if(id == 4){
                this.dataFoto.activeFotoPendukung3Base64 = this.dataFoto.urlFotoPendukung3
            }else if(id == 5){
                this.dataFoto.activeFotoFormSurveyBase64 = this.dataFoto.urlFotoFormSurvey
            }else {
                this.dataFoto.activeFotoFormDataBpkbBase64 = this.dataFoto.urlFotoFormDataBpkb
            }
        },

        removeFotoPendukung(id){
            if(id == 1){
                this.dataFoto.activeFotoPendukung1Base64 = null
            }else if(id == 2){
                this.dataFoto.activeFotoPendukung2Base64 = null
            }else if(id == 3){
                this.dataFoto.activeFotoPendukung3Base64 = null
            }else if(id == 4){
                this.dataFoto.activeFotoFormSurveyBase64 = null
            }else {
                this.dataFoto.activeFotoFormDataBpkbBase64 = null
            }
        },

        browseFile(id) {
            const fileInputRef = this.$refs[`fileInput${id}`]

            let file = null
            if (id == 5) file = this.dataFoto.fotoFormSurvey
            else if (id == 1) file = this.dataFoto.fotoIdentitas
            else if (id == 2) file = this.dataFoto.fotoPendukung1
            else if (id == 3) file = this.dataFoto.fotoPendukung2
            else if (id == 4) file = this.dataFoto.fotoPendukung3
            else file = this.dataFoto.fotoFormDataBpkb

            if (!file) {
                return
            }

            this.toBase64(file)
                .then(async base64 => {
                    if (id == 5) {
                        this.dataFoto.activeFotoFormSurveyBase64 = base64
                    } else if (id == 1) {
                        this.dataFoto.activeFotoIdentitasBase64 = await this.$helper.resizeImage(base64)
                    } else if (id == 2) {
                        this.dataFoto.activeFotoPendukung1Base64 = await this.$helper.resizeImage(base64)
                    } else if (id == 3) {
                        this.dataFoto.activeFotoPendukung2Base64 = await this.$helper.resizeImage(base64)
                    } else if (id == 4) {
                        this.dataFoto.activeFotoPendukung3Base64 = await this.$helper.resizeImage(base64)
                    } else {
                        this.dataFoto.activeFotoFormDataBpkbBase64 = await this.$helper.resizeImage(base64)
                    }

                    if (fileInputRef) fileInputRef.reset()
                })
                .catch(error => {
                    console.log(error)
                    this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
                })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        openModalPreview(id){
            if(id == 1){
                this.activeFotoPreview = this.dataFoto.activeFotoIdentitasBase64
            }else if(id == 2){
                this.activeFotoPreview = this.dataFoto.activeFotoPendukung1Base64
            }else if(id == 3){
                this.activeFotoPreview = this.dataFoto.activeFotoPendukung2Base64
            }else if(id == 4){
                this.activeFotoPreview = this.dataFoto.activeFotoPendukung3Base64
            }else if(id == 5){
                this.activeFotoPreview = this.dataFoto.activeFotoFormSurveyBase64
            }else {
                this.activeFotoPreview = this.dataFoto.activeFotoFormDataBpkbBase64
            }
            
            this.$bvModal.show("modal-preview-foto")
        },

        onCamera(id) {
            this.activeId = id
            this.$refs.cameraInput.click();
        },

        handleKameraMobile(event) {
            const file = event.target.files[0];
            if (!file) return;

            const id = this.activeId;

            if (id == 1) this.dataFoto.fotoIdentitas = file;
            else if (id == 2) this.dataFoto.fotoPendukung1 = file;
            else if (id == 3) this.dataFoto.fotoPendukung2 = file;
            else if (id == 4) this.dataFoto.fotoPendukung3 = file;
            else if (id == 5) this.dataFoto.fotoFormSurvey = file;
            else this.dataFoto.fotoFormDataBpkb = file;

            this.browseFile(id);
        }

    }
}
</script>